export default __webpack_public_path__ + "static/media/step_I_UA.7cb08f94.png";